'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.LANGUAGE_CHANGE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getInitialLang = getInitialLang;
exports.default = languageReducer;

var _cookies = require('./cookies');

var LANGUAGE_CHANGE = exports.LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';

function getInitialLang() {
  var lang = 'en';
  if (isBrowser) {
    lang = document.documentElement.lang || lang;
  }

  return lang;
}

var initialState = exports.initialState = { lang: getInitialLang() };

function languageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LANGUAGE_CHANGE:
      {
        (0, _cookies.setCookie)('forceLocale', action.language);
        return _extends({}, state, { lang: action.language });
      }
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@axa-asia/hk-shared-utils/lib/languageReducer.js
// module id = 402
// module chunks = 0